<template>
  <div style="margin:1%">
    <b-list-group v-if="isCreated" flush >
      <b-list-group-item>
        <b-row>
          <label> {{ $t("Send at that time") }} </label>
          <b-form-select v-model="notificationPolicyRecord.appointed_time" :options="optionsAppointedTime" value-field="value" text-field="name"/>
        </b-row>
      </b-list-group-item>
      <b-list-group-item>
        <b-row>
          <b-col>
            <b-form-checkbox v-model="notificationPolicyRecord.send_email">{{ $t('Send Email') }}</b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox v-model="notificationPolicyRecord.send_sms">{{ $t('Send SMS') }}</b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox v-model="notificationPolicyRecord.send_push">{{ $t('Send Push') }}</b-form-checkbox>
          </b-col>
        </b-row>
      </b-list-group-item>
      <b-list-group-item>
        <b-row>
          <label> {{ $t('Warn about blocking that number of days in advance') }} </label>
          <b-input type="number" v-model.number="notificationPolicyRecord.block_prediction_days" min="0" max="45" step="1"/>
        </b-row>
      </b-list-group-item>
      <b-list-group-item>
        <b-row>
          <label> {{ $t('Warn about lack of funds at next balance') }} </label>
          <b-input type="number" v-model.number="notificationPolicyRecord.balance_threshold" min="0" step="1"/>
        </b-row>
      </b-list-group-item>
    </b-list-group>
  <b-button v-if="!isCreated" @click="generate"> {{ $t('Create policy for user') }} </b-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isCreated: false,
      isAppointedTime: false,
      optionsAppointedTime: [
        {name: '---', value: ''},
        {name: '00:00', value: '00:00'},
        {name: '01:00', value: '01:00'},
        {name: '02:00', value: '02:00'},
        {name: '03:00', value: '03:00'},
        {name: '04:00', value: '04:00'},
        {name: '05:00', value: '05:00'},
        {name: '06:00', value: '06:00'},
        {name: '07:00', value: '07:00'},
        {name: '08:00', value: '08:00'},
        {name: '09:00', value: '09:00'},
        {name: '10:00', value: '10:00'},
        {name: '11:00', value: '11:00'},
        {name: '12:00', value: '12:00'},
        {name: '13:00', value: '13:00'},
        {name: '14:00', value: '14:00'},
        {name: '15:00', value: '15:00'},
        {name: '16:00', value: '16:00'},
        {name: '17:00', value: '17:00'},
        {name: '18:00', value: '18:00'},
        {name: '19:00', value: '19:00'},
        {name: '20:00', value: '20:00'},
        {name: '21:00', value: '21:00'},
        {name: '22:00', value: '22:00'},
        {name: '23:00', value: '23:00'}
      ]
    }
  },
  props: {
    notificationPolicyRecord: {}
  },
  methods: {
    generate () {
      this.notificationPolicyRecord.send_sms = false
      this.notificationPolicyRecord.send_email = false
      this.notificationPolicyRecord.send_push = false
      this.notificationPolicyRecord.send_at_appointed_time = false
      this.notificationPolicyRecord.appointed_time = ''
      this.notificationPolicyRecord.block_prediction_days = 14
      this.notificationPolicyRecord.balance_threshold = 0
      this.isCreated = true
    }
  },
  mounted () {
    this.isCreated = (Object.keys(this.notificationPolicyRecord).length > 0)
    this.isAppointedTime = this.notificationPolicyRecord.send_at_appointed_time
  },
  watch: {
    isAppointedTime: function (val) {
      this.notificationPolicyRecord.send_at_appointed_time = val
      return this.notificationPolicyRecord.send_at_appointed_time
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/notificationPolicy/main.vue